import { ActionType, createReducer } from 'typesafe-actions';

import * as actions from './earn.actions';
import { initialState } from './earn.initialState';
import { mapEarnHistoryFromServer, mapEarnSubscriptionsFromServer, mapProductsFromServer } from './earn.mapper';

type State = typeof initialState;
type Actions = ActionType<typeof actions>;

export const earnReducer = createReducer<State, Actions>(initialState)
  .handleAction(actions.actionLoadingGetEarnProducts, (state) => ({
    ...state,
    loading: {
      ...state.loading,
      products: state.loading.productsInitial,
    },
  }))
  .handleAction(actions.actionSuccessGetEarnProducts, (state, action) => ({
    ...state,
    products: mapProductsFromServer(action.payload),
    loading: {
      ...state.loading,
      productsInitial: false,
      products: false,
    },
  }))
  .handleAction(actions.actionErrorGetEarnProducts, (state) => ({
    ...state,
    loading: {
      ...state.loading,
      productsInitial: false,
      products: false,
    },
  }))
  .handleAction(actions.actionGetEarnSubscriptions, (state) => ({
    ...state,
    loading: {
      ...state.loading,
      subscriptions: state.loading.subscriptionsInitial,
    },
  }))
  .handleAction(actions.actionSuccessGetEarnSubscriptions, (state, action) => ({
    ...state,
    subscriptions: mapEarnSubscriptionsFromServer(action.payload.data, state.products),
    loading: {
      ...state.loading,
      subscriptionsInitial: false,
      subscriptions: false,
    },
  }))
  .handleAction(actions.actionErrorGetEarnSubscriptions, (state) => ({
    ...state,
    loading: {
      ...state.loading,
      subscriptionsInitial: false,
      subscriptions: false,
    },
  }))
  .handleAction(actions.actionGetEarnHistory, (state) => ({
    ...state,
    loading: {
      ...state.loading,
      history: state.loading.historyInitial,
    },
  }))
  .handleAction(actions.actionSuccessGetEarnHistory, (state, action) => ({
    ...state,
    history: mapEarnHistoryFromServer(action.payload.data, state.products),
    loading: {
      ...state.loading,
      history: false,
      historyInitial: false,
    },
  }))
  .handleAction(actions.actionErrorGetEarnHistory, (state) => ({
    ...state,
    loading: {
      ...state.loading,
      history: false,
      historyInitial: false,
    },
  }))
  .handleAction(actions.actionGetEarnSubscriptionTransactions, (state) => ({
    ...state,
    transactions: initialState.transactions,
    loading: {
      ...state.loading,
      transactions: true,
    },
  }))
  .handleAction(actions.actionSuccessGetEarnSubscriptionTransactions, (state, action) => ({
    ...state,
    transactions: action.payload.data || initialState.transactions,
    loading: {
      ...state.loading,
      transactions: false,
      transactionsInitial: false,
    },
  }))
  .handleAction(actions.actionErrorGetEarnSubscriptionTransactions, (state) => ({
    ...state,
    loading: {
      ...state.loading,
      transactions: false,
      transactionsInitial: false,
    },
  }))
  .handleAction(actions.actionSetEarnSubscriptionsFilters, (state, action) => ({
    ...state,
    subscriptionsFilters: {
      ...state.subscriptionsFilters,
      ...action.payload,
    },
  }));
